<template>
  <v-container
    id="catalog"
    tag="section"
  >
    <v-card>
      <v-card-title>
        {{ $t('catalog.title') }}
        <v-spacer />
        <v-btn color="secondary" @click="exportJson">
          Export JSON
        </v-btn> 
        <v-btn color="primary" @click="createItemDialog">
          Add Module
        </v-btn> 
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col>
            <v-text-field
          v-model="search"
            class="searchBox"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            :aria-label="$t('global.text-field')+' '+$t('global.search') +' '+ $t('catalog.title')"
            single-line
            hide-details
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col>
      <v-data-table
        v-model="selected"
        filterable
        :headers="headers.map((x) => { return { ...x, text: $t(x.text) } })"
        :items="items"
        item-key="id"
        :loading="loading"
        :search="search"
        :items-per-page="30"
      >
        <template v-slot:item.title="{ item }">
          {{ getTitle(item) }}
        </template>"
        <template v-slot:item.actions="{ item }">
             <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  class="mr-2"
                  :aria-label="$t('global.edit') + ' ' + $t('modules.moduleParam', [item.id])"
                  v-on="on"
                  @click="editItem(item)"
                >
                  mdi-pencil-outline
                </v-icon>
              </template>
              <span>{{ $t('edit') }}</span>
             </v-tooltip>
             <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-icon
                    :aria-label="$t('global.delete') + ' ' + $t('modules.moduleParam', [item.id])"
                    v-on="on"
                    @click="deleteItem(item)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </template>
                <span>{{ $t('delete') }}</span>
             </v-tooltip>
          </template>
      </v-data-table>
    </v-col>
    </v-row>
    </v-card-text>
    </v-card>
    <v-row justify="center">
      <v-dialog
        v-model="showEditDialog"
        max-width="800px"
      >
      <catalog-edit 
        :moduleid="selectedItemID"
        @cancel="closeEditDialog"
        @save="saveEditDialog"
      />
      </v-dialog>
      <v-dialog v-model="showConfirmDeleteDialog" max-width="500px">
          <v-card>
            <v-card-title>{{ $t('global.confirm') }}</v-card-title>
            <v-card-text>{{ $t('catalog.confirm-delete') }} <span class="font-weight-bold">{{ selectedItemID }}</span>?</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue" @click="cancelDelete">
                {{ $t('global.no') }}
              </v-btn>
              <v-btn color="red" @click="confirmDelete">
                {{ $t('global.yes') }}
              </v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import 'firebase/auth'
  import CatalogEdit from './CatalogEdit.vue'
  import api from '@/helpers/api.js'
  import { ContentLibrary } from '@/helpers/contentLibrary.js'

  export default {
    name: 'Catalog',

    components: {
      'catalog-edit': CatalogEdit,
    },

    data: () => ({
      loading: true,
      headers: [
        { text: 'catalog.header.id', sortable: true, value: 'uid' },
        { text: 'catalog.header.title', sortable: true, value: 'title' },
        { text: 'catalog.header.type', sortable: true, value: 'type' },
        { text: 'catalog.header.aiUsage', sortable: true, value: 'aiUsage' },
        { text: 'catalog.header.public', sortable: true, value: 'public' },
        { text: 'catalog.header.actions', value: 'actions', sortable: false },
      ],
      items: [],
      selected: undefined,
      selectedItemID: undefined,
      showEditDialog: false,
      showConfirmDeleteDialog: false,
      search: '',
    }),

    computed: {
      
    },

    async mounted () {
      this.loading = true
      await this.refreshItems()
      this.loading = false
    },

    methods: {
      getTitle (item) {
        return item.locales?.[this.$i18n.locale]?.title ?? item.locales?.en?.title ?? item.title
      },
      async refreshItems () {
        this.loading = true
        this.items = await ContentLibrary.Get(this.$store, this.$i18n)
        // console.log(this.items)
        this.loading = false
      },
      exportJson: function () {
        const json = JSON.stringify(this.items, null, 2)
        // open a new window to download this to the browser
        const blob = new Blob([json], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'contents.json')
        document.body.appendChild(link)
        link.click()
      },
      async createItemDialog () {
        this.selectedItemID = null
        this.showEditDialog = true
      },
      async editItem (item) {
        this.selectedItemID = item.uid
        this.showEditDialog = true
      },
      closeEditDialog () {
        this.showEditDialog = false
      },
      async saveEditDialog () {
        this.refreshItems(true)
        this.showEditDialog = false
      },
      async confirmDelete () {
        const index = this.items.findIndex(x => x.uid === this.selectedItemID)
        // console.log(index)
        this.items.splice(index, 1)
        // console.log('deleting item ' + this.selectedItemID)
        await api.deleteContent(this.selectedItemID)
        this.cancelDelete()
      },
      deleteItem (item) {
        this.selectedItemID = item.uid
        this.showConfirmDeleteDialog = true
      },
      cancelDelete () {
        this.showConfirmDeleteDialog = false
        this.$nextTick(() => {
          this.selectedItemID = null
        })
      },
    },

  }
</script>

<style>
</style>
